import { Post } from '../fetch';

export default {
  // 获取场景下监控设备列表
  fetchMonitorList (params) {
    return Post('/basis/monitorSiteDev/getDevList', params);
  },
  // 获取场景下所有监控设备的播放信息
  fetchMonitorLiveDataByScene (params) {
    return Post('/basis/monitorSiteDev/getPlayInfoListBySite', params);
  },
  // 获取场景下的监控设备信息
  fetchMonitorLiveData (params) {
    return Post('/basis/monitorSiteDev/getMonitorDevPlayInfo', params);
  }
};
